import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3011/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Initialize tokens from localStorage if they exist
const userToken = localStorage.getItem('token');
const ngoToken = localStorage.getItem('ngoToken');

if (userToken) {
  api.defaults.headers.common['x-auth-token'] = userToken;
}

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // Check if this is an NGO request and set appropriate token
    if (config.url && (config.url.includes('/ngos') || config.url.includes('/volunteers') || config.url.includes('/projects'))) {
      const ngoToken = localStorage.getItem('ngoToken');
      if (ngoToken) {
        config.headers['x-auth-token'] = ngoToken;
        console.log('Setting NGO token for request to:', config.url);
      } else {
        console.log('No NGO token found for request to:', config.url);
      }
    } else {
      // Regular user token
      const userToken = localStorage.getItem('token');
      if (userToken) {
        config.headers['x-auth-token'] = userToken;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.log('Authentication error:', error.response?.status);
      
      // Check if this is an NGO request
      const isNGORequest = error.config?.url && (
        error.config.url.includes('/ngos') || 
        error.config.url.includes('/volunteers') || 
        error.config.url.includes('/projects')
      );
      
      // Check if we're already on a login page
      const isOnLoginPage = window.location.pathname.includes('/login');
      const isVehicleRegistration = window.location.pathname.includes('/vehicle-registration');
      
      if (!isOnLoginPage && !isVehicleRegistration) {
        if (isNGORequest) {
          console.log('NGO authentication error, redirecting to NGO login');
          localStorage.removeItem('ngoToken');
          localStorage.removeItem('ngo');
          
          setTimeout(() => {
            window.location.href = '/ngo/login';
          }, 100);
        } else {
          console.log('User authentication error, redirecting to user login');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('userType');
          
          setTimeout(() => {
            window.location.href = '/login';
          }, 100);
        }
      } else if (isVehicleRegistration) {
        console.log('Authentication error on vehicle registration page, not redirecting');
      }
    }
    return Promise.reject(error);
  }
);

export default api;